import { createContext } from 'react';

type IntersectionObserverContextType = {
  entries: Map<Element, IntersectionObserverEntry>;
  observe: (_: HTMLElement, __: IntersectionObserverInit) => void;
  unobserve: (_: HTMLElement, __: IntersectionObserverInit) => void;
};

export const IntersectionObserverContext = createContext<IntersectionObserverContextType | undefined>(undefined);
